import "./Loader.css";

const Loader = () => {
  return (
    <div
      className="flex fixed justify-center items-center text-center h-screen w-screen bg-[#000000] bg-opacity-80"
      style={{
        height: "100%",
        zIndex: 2,
      }}
    >
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
